module.exports = __webpack_public_path__ + "img/successfulPop.30c26cc5.png";